if (!customElements.get('mefyto-short-reviews')) {
  customElements.define('mefyto-short-reviews', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.track = this.querySelector('[data-review-track]');
      this.slides = [...this.querySelectorAll('[data-review-slide]')];
      this.dots = [...this.querySelectorAll('[data-review-dot]')];
      if (!this.track || this.slides.length < 2) return;
      this.current = 0;
      this.paused = false;
      this.hovered = false;
      this.focused = false;
      this.visible = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      const on = (node, event, handler) => node?.addEventListener(event, handler, { signal: this.controller.signal });
      this.dots.forEach((dot, index) => on(dot, 'click', () => this.go(index)));
      on(this.track, 'scroll', () => {
        const index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / this.track.clientWidth)));
        if (index !== this.current) { this.current = index; this.update(); }
      });
      on(this.track, 'keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.go(this.current + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      on(this, 'mouseenter', () => { this.hovered = true; this.restart(); });
      on(this, 'mouseleave', () => { this.hovered = false; this.restart(); });
      on(this, 'focusin', () => { this.focused = true; this.restart(); });
      on(this, 'focusout', (event) => { this.focused = this.contains(event.relatedTarget); this.restart(); });
      on(document, 'visibilitychange', () => this.restart());
      on(this.motion, 'change', () => this.restart());
      on(this.querySelector('[data-review-pause]'), 'click', () => { this.paused = !this.paused; this.update(); this.restart(); });
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.restart();
      }, { threshold: .5 });
      this.observer.observe(this);
      this.resize = new ResizeObserver(() => this.track.scrollTo({ left: this.current * this.track.clientWidth, behavior: 'instant' }));
      this.resize.observe(this.track);
      this.setAttribute('data-ready', '');
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      clearInterval(this.timer);
      this.observer?.disconnect();
      this.resize?.disconnect();
    }
    go(index) {
      this.current = (index + this.slides.length) % this.slides.length;
      this.track.scrollTo({ left: this.current * this.track.clientWidth, behavior: this.motion.matches ? 'instant' : 'smooth' });
      this.update();
      this.restart();
    }
    update() {
      this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.current)));
      const pause = this.querySelector('[data-review-pause]');
      if (pause) {
        pause.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        pause.setAttribute('aria-pressed', String(this.paused));
        pause.textContent = this.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
      }
    }
    restart() {
      clearInterval(this.timer);
      if (this.dataset.autoplay !== 'true' || this.paused || this.hovered || this.focused || !this.visible || document.hidden || this.motion.matches) return;
      this.timer = setInterval(() => this.go(this.current + 1), Number(this.dataset.interval || 6) * 1000);
    }
  });
}
